export default function (state) {
    let load = false;
    state.list.forEach(i => {
        if (i.load) load = true;
    });
    return load;
}